/* unplugin-vue-components disabled */import "core-js/modules/es.array.find.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCategoryList, getSubLevelCategoryList } from '@/api';
export default {
  name: 'classification',
  data: function data() {
    return {
      classificationData: [],
      sidebarData: [],
      title: '',
      seachForm: {
        keyword: '',
        parent_id: 0
      },
      active: 0
    };
  },
  methods: {
    onChange: function onChange() {
      var _this = this;
      var obj = this.sidebarData.find(function (item, index) {
        return index === _this.active;
      });
      this.title = obj.classification_name;
      getSubLevelCategoryList({
        fk_t_shop_classification_id: obj.fk_t_shop_classification_id
      }).then(function (res) {
        if (res.success) {
          _this.classificationData = res.data;
        }
      });
    },
    getData: function getData() {
      var _this2 = this;
      getCategoryList(_objectSpread({}, this.seachForm)).then(function (res) {
        if (res.success) {
          _this2.sidebarData = res.data;
          _this2.onChange();
        }
      });
    },
    goClassificationList: function goClassificationList(item) {
      this.$router.push({
        name: 'classificationList',
        params: {
          id: item.fk_t_shop_classification_id
        }
      });
    }
  },
  created: function created() {
    this.getData();
  }
};